/** @jsx jsx */
import { jsx } from '@emotion/react';

import styles from 'bundles/megamenu/components/__styles__/MegaMenuContent';

export type Props = {
  menuIsOpen: boolean;
  openMenu: () => void;
  closeMenu: () => void;
};

export const SimplifiedMegamenuContainer = (props: Props) => {
  const { menuIsOpen, openMenu, closeMenu } = props;

  return (
    <div
      css={[styles.simplifiedMegaMenuOverlay, !menuIsOpen && styles.megaMenuOverlayHidden]}
      aria-hidden={!menuIsOpen}
    >
      <nav css={styles.simplifiedMegamenuContainer} onMouseEnter={openMenu} onMouseLeave={closeMenu}>
        <div css={styles.megaMenuContentContainer}></div>
      </nav>
    </div>
  );
};

export default SimplifiedMegamenuContainer;
